import { gql } from "@edreamsodigeo/frontend-api-client";

import { SUBSCRIPTION_OFFER_FIELDS } from "./membershipSubscriptionOffer";

const MEMBERSHIP_PRODUCT_FIELDS = gql`
  ${SUBSCRIPTION_OFFER_FIELDS}
  fragment MembershipSubscriptionResponse on MembershipSubscriptionResponse {
    offerAdded {
      ...SubscriptionOffer
    }
    primeMember {
      name
      lastNames
    }
  }
`;

export const GET_MEMBERSHIP_PRODUCT = gql`
  ${MEMBERSHIP_PRODUCT_FIELDS}
  query MembershipProduct(
    $membershipProductRequest: GetMembershipProductRequest
  ) {
    membershipProduct(membershipProductRequest: $membershipProductRequest) {
      ...MembershipSubscriptionResponse
    }
  }
`;

export const UPDATE_MEMBERSHIP_PRODUCT = gql`
  ${MEMBERSHIP_PRODUCT_FIELDS}
  mutation UpdateMembershipProduct(
    $updateMembershipProductRequest: UpdateMembershipProductRequest
  ) {
    updateMembershipProduct(
      updateMembershipProductRequest: $updateMembershipProductRequest
    ) {
      ...MembershipSubscriptionResponse
    }
  }
`;

export const UPDATE_SUBSCRIPTION_PRODUCT_BIN_BASED = gql`
  ${MEMBERSHIP_PRODUCT_FIELDS}
  mutation UpdateSubscriptionProductBinBased(
    $updateSubscriptionProductBinBasedRequest: UpdateSubscriptionProductBinBasedRequest!
  ) {
    updateSubscriptionProductBinBased(
      updateSubscriptionProductBinBasedRequest: $updateSubscriptionProductBinBasedRequest
    ) {
      ...MembershipSubscriptionResponse
    }
  }
`;
